<template>
    <div>
        <p class="lh20">&nbsp;</p>
        <div class="zt_page">
            <router-link :to="{path:'/detail', query:{id:'245',showVideo:1,title:'震动棒炮机成人情趣女用品自慰器性用具玩具女性自神器慰插入高潮'}}"  target="_blank" class="t_god">
            <!-- <a href="javascript:;" class="t_god"> -->
                <img src="../../assets/picture/index/vip-banner/1.jpg" width="494" height="300">
            <!-- </a> -->
            </router-link>
            <router-link :to="{path:'/detail', query:{id:'242',showVideo:1,title:'日本全自动飞机杯男用品自慰深喉舌舔口交器熟女电动真阴专用神器'}}"  target="_blank" class="t_god ml1">
            <!-- <a href="javascript:;" class="t_god ml1"> -->
                <img src="../../assets/picture/index/vip-banner/2.jpg" width="494" height="300">
            <!-- </a> -->
            </router-link>
            <div class="clear"></div>
            <router-link :to="{path:'/detail', query:{id:'239',showVideo:1,title:'全自动罗格深喉飞机杯男用电动神器性成人用品熟女夹吸口交自慰器'}}"  target="_blank" class="t_god">
            <!-- <a href="javascript:;" class="t_god"> -->
                <img src="../../assets/picture/index/vip-banner/3.jpg" width="494" height="300">
            <!-- </a> -->
            </router-link>
            <router-link :to="{path:'/detail', query:{id:'234',showVideo:1,title:'飞机杯全自动性用具男用自慰器深喉夹吸口交专用成人情趣用品真阴'}}"  target="_blank" class="t_god ml1">
            <!-- <a href="javascript:;" class="t_god ml1"> -->
                <img src="../../assets/picture/index/vip-banner/4.jpg" width="494" height="300">
            <!-- </a> -->
            </router-link>
            <div class="clear"></div>
            <ul class="w_ztul">
                <li>
                    <router-link :to="{path:'/detail', query:{id:'239',showVideo:1,title:'全自动罗格深喉飞机杯男用电动神器性成人用品熟女夹吸口交自慰器'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/1887.jpg" class="" width="34" height="34">
                        你的<em class="red">唇爱神器</em>
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'224',showVideo:1,title:'全自动伸缩阳具仿真假阴茎罗马大帝女性自慰卫器自尉棒加温炮击机'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/21005.jpg" class="" width="34" height="34">
                        <em class="red">冲撞</em>她的蜜道
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'231',showVideo:1,title:'延时喷剂持久不射喷雾印度神油不麻木男用品延长时间延迟猛男男士'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/9750.jpg" class="" width="34" height="34">
                        <em class="red">做持久</em>真男人
                    <!-- </a> -->
                    </router-link>
                </li>
                <li>
                    <router-link :to="{path:'/detail', query:{id:'235',showVideo:1,title:'飞机男杯下半身实体真人倒模熟女大硅胶屁股男性专用成人用品玩具'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/20900.jpg" class="" width="34" height="34">
                        你的<em class="red">私宠娇妻</em>
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'240',showVideo:1,title:'震动棒成人情趣女用品自慰器性用具玩具女性自神器慰插入工具高潮'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/21337.jpg" class="" width="34" height="34">
                        <em class="red">深撩</em>她的花心
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'82',showVideo:1,title:'人体润滑剂油情趣免洗快感液精油私处调情房事男用抽插夫妻用品ky'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/21312.jpg" class="" width="34" height="34">
                        <em class="red">爱液多</em>更舒爽
                    <!-- </a> -->
                    </router-link>
                </li>
                <li>
                    <router-link :to="{path:'/detail', query:{id:'68',showVideo:1,title:'男用品自慰器男性名器成人情趣性玩具撸管打飞机用具自尉男士神器'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/20941.jpg" class="" width="34" height="34">
                        你的<em class="red">性爱伴侣</em>
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'74',showVideo:1,title:'延时喷剂持久不射印度神油男用品成人性保健时间男性延迟喷雾延长'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/21036.jpg" class="" width="34" height="34">
                        点燃她的<em class="red">欲望</em>
                    <!-- </a> -->
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:'177',showVideo:1,title:'第六感花样情趣%2B冰火激情两种组合任你选立减10元'}}"  target="_blank" class="w_zta">
                    <!-- <a href="javascript:;" class="w_zta"> -->
                        <img src="../../assets/image/ranking/20663.jpg" class="" width="34" height="34">
                        <em class="red">安全套</em>也刺激
                    <!-- </a> -->
                    </router-link>
                </li>
            </ul>
            <div class="clear"></div>
            <div class="over">
                <router-link :to="{path:'/shop/shopsearch', query:{cate_id:22,showVideo:1,title:'外用延时'}}" target="_blank" class="zt_w3">
                    <img src="../../assets/image/ranking/yanshiyy.jpg" width="328" height="110">
                </router-link>
                <router-link :to="{path:'/shop/shopsearch', query:{cate_id:6,showVideo:1,title:'飞机杯'}}" target="_blank" class="zt_w3 ml2">
                    <img src="../../assets/image/ranking/feijibei.jpg" width="328" height="110">
                </router-link>
                <router-link :to="{path:'/nxzw'}" target="_blank" class="zt_w3 ml2">
                    <img src="../../assets/image/ranking/20180509183011_r1_c1.jpg" width="328" height="110">
                </router-link>
            </div>
            <div class="over">
                <div v-for="(item,index) in soncate.slice(0,9)" :key="index">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id,showVideo:1,title:item.title}}" target="_blank" class="w_ztb">
                        <img :src="item.piclink" class="w_ztm">
                        <p>{{item.title}}</p>
                    </router-link>
                </div>
            </div>
            <!--one over-->
            <public-ranking></public-ranking>
            <p class="lh20">&nbsp;</p>
        </div>
    </div>
</template>

<script>
import Public_ranking from "@/components/common/public-ranking.vue"
export default {
    components:{
        'public-ranking': Public_ranking,
    },
    data(){
        return{
            //数据
            soncate:[],
        }
    },
    mounted() {
        this.getSonCate();
    },
    methods:{
         //获取所有子分类
        getSonCate() {
            this.$api.getCategory.getSonCate({}).then(res => {
                if (res.code == 200) {
                    this.soncate = [];
                    var arr = res.result.soncate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.soncate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        nxzw(){
            //指定跳转地址
			this.$router.replace('/nxzw')
        }
    }
}
</script>

<style scoped>
/* @import url('../../assets/css/zt.css'); */
body{background:#eee url(../../assets/image/ranking/bg01.jpg) 50% 168px no-repeat;}
.topbar{width:990px;}
.wp{width:990px;}
.fa_dl{width:164px;}
.dlast{width:163px;}
.w990,.zt_page{width:990px;margin:0 auto;}
.zt_page{overflow: hidden;font-family:"Microsoft Yahei";}
.t_god{width:494px;height:280px;overflow:hidden;display:inline;float:left;margin-bottom:1px;_margin-bottom:0; background-color: #000;_background-color: #fff;}
.t_god img,.zt_w3 img,.w_ztm{-webkit-transition:all 0.3s;-moz-transition:all 0.3s;transition:all 0.3s;}
.t_god:hover img{opacity:0.8;}
.ml1{margin-left:1px;}
.ml2{margin-left:3px;}
.w_ztul{overflow:hidden;zoom:1;margin:20px 0;}
.w_ztul li{width: 33.3%;float:left; line-height: 38px;overflow: hidden; white-space: nowrap;}
.w_zta{display: block;width: 100%; font-size: 16px;margin:5px 0;color:#333; overflow: hidden; text-overflow: ellipsis;}
.w_zta img{display:inline-block;margin-right:10px;vertical-align: middle;}
.w_zta:hover{ background-color: #ddd;color:#c40000; text-decoration: none;}
.zt_w3{width:328px;height:110px; display: inline; float: left; background-color: #000;_background-color: #eee;}
.zt_w3:hover img{opacity:0.8;}
.w_ztb{width:54px;height:80px; line-height: 30px;color:#333;float:left; text-align: center;display: inline;margin:30px 50px 0 0;}
.w_ztbb{margin-right:0;}
.w_ztb:hover{text-decoration: none;color:#c40000;}
.w_ztb:hover .w_ztm{-webkit-transform:scale(0.9); -moz-transform:scale(0.9);transform:scale(0.9);}
.zt_tts{padding-top:20px;background: url(../../assets/image/ranking/ht.png) 0 0 repeat-x; overflow: hidden;zoom:1; line-height: 30px;margin:40px 0 10px 0;}
.zt_vlm{ display:inline-block;float: left;margin-right:10px;}
.zt_h2{float: left;font-size:20px;color:#000; font-weight: bold; display: inline-block;}
.zt_ra{float:right;color:#777; font-size: 14px;}
.zt_ra:hover{color:#c40000;}
.zt_tts em{float:right;color:#cacaca;margin:0 10px;}
.zt_more{float:right;color:#000; background: url(../../assets/image/ranking/more.png) right 50% no-repeat;padding-right:25px; font-size: 14px;}

.zt_glst{width:1000px;margin-left:-10px;}
.zt_aa{width:240px;height:364px;display: inline;float: left; overflow: hidden;margin:10px 0 0 10px;color:#333; background-color: #fff; line-height:20px;}
.z_tta{padding:0 10px;font-size:14px;height: 40px; overflow: hidden;margin:5px 0;}
.zt_aa .ov{margin:10px 0;}
.zt_aa .left{color:#c40000; font-size: 16px;margin-left:10px;}
.zt_aa .right{color:#999;margin-right: 10px;}
.zt_bm{width:220px;height: 26px; background-color: #e74573; line-height: 26px;color:#fff; text-align: center;margin:0 auto;}
.zt_aa:hover{text-decoration: none;color:#c40000;}
.zt_aa:hover .zt_bm{ background-color: #c40000;}

.gfix{ position: fixed;left:0;top:0;width:100%;z-index:100;_position:relative;}
.gtops{display:block;width:30px;height:30px;padding:10px;background-color:#333;position: fixed;left:50%;bottom:80px;margin-left: 520px;z-index:10;}
.hid{display:none;}
.fl_open_wrap{display:none;position:fixed;z-index:99999;left:0;bottom:55px;width:190px;height:185px;overflow:hidden;}
.fl_open_wrap .fl_open_wrap_cntr{position:absolute;left:0;top:0;width:100%;height:100%;background:url(http://qu.dddxi.com/topic/xpcrexiao/themes/v4/css/2/fl_open.png) no-repeat;cursor: pointer;background-size: contain;}
.fl_pop_wrap{display:none;position:fixed;z-index:99998;left:0;bottom:0;width:100%;height:200px;overflow:hidden;}
.fl_open_show{position:absolute;left:-100%;bottom:0;width:100%;z-index: 210}
.fl_open_bg{width:100%;height:170px;background:rgba(26,22,55,1);z-index:-200;position: relative;}
.fl_open_m{width: 790px;height: 170px;position: absolute;bottom:0;left: 50%;z-index: 200;margin-left: -395px;opacity: 1}
.fl_pop_wrap .fl_pop_ttl,.fl_pop_wrap input,.fl_pop_wrap .fl_pop_btn_normal{font-family:"Microsoft YaHei","Hiragino Sans GB";}
.fl_pop_wrap .fl_close{position:absolute;top:10px;right:0;font-size:38px;line-height:1.2;font-family:Simsun;color:#9aa1a8;outline:0 none;}
#erma{display:none}

.w_ztm{width:54px;height:54px;}
</style>


// WEBPACK FOOTER //
// src/components/ranking/Index.vue